module.exports = __webpack_public_path__ + "static/media/risk_token.04a2bb5b.png";